import { render } from "./UpgradeScreen.vue?vue&type=template&id=fe668f50&scoped=true"
import script from "./UpgradeScreen.vue?vue&type=script&lang=js"
export * from "./UpgradeScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=fe668f50&lang=scss&scoped=true"
import "./UpgradeScreen.vue?vue&type=style&index=1&id=fe668f50&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe668f50"]])

export default __exports__